import { diffDays } from "@insightfulscience/shared-utils/dates/dateDiff";

export const daysBeforeNow = date => diffDays(new Date(), new Date(date));
